//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    skill: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      validationValue: undefined,
    }
  },
  mounted() {
    this.validationValue = this.hasSkill(this.skill)
  },
  methods: {
    hasSkill(skill) {
      if (skill.supervisor_validate_skill == null) {
        return null
      }
      return skill.supervisor_validate_skill
    },
  },
}
